import { TextField } from "@mui/material";
import React from "react";

export default function CommLogSearch({ logType, searchValue, setSearchField, resetPagination }) {
  return (
    <div className="mt-6 pr-2">
      <div className="mx-3 mt-20 flex items-center">
        <TextField
          className="w-full rounded-lg text-sm placeholder:text-center"
          placeholder={
            logType === "sms"
              ? "Search By Phone Number or Message Contents"
              : "Search By Phone Number"
          }
          size="small"
          name="callLog-search"
          value={searchValue}
          InputLabelProps={{ shrink: true }}
          label="Search"
          onChange={(event) => {
            setSearchField(event.target.value);
            resetPagination();
          }}
        />
      </div>
    </div>
  );
}
